import { CustomerContractTypeModel } from './customer-contract-type-model';
import { UserModel } from '../../../core/user-model.model';
import { Serializable } from '../../../core/models/serializable';

export class CustomerContractModel
  implements Serializable<CustomerContractModel>
{
  fromObject(obj: any): CustomerContractModel {
    Object.assign(this, obj);
    this.customer = null;
    this.createUser = null;
    this.type = null;

    if (obj.customer != null) {
      this.customer = obj.customer.customerId;
    }

    if (obj.createUser != null) {
      let t = new UserModel();
      t = t.fromObject(obj.createUser);
      this.createUser = t;
    }

    if (obj.type != null) {
      let t = new CustomerContractTypeModel();
      t = t.fromObject(obj.type);
      this.type = t;
    }

    return this;
  }

  toObject() {
    let result = {
      Customer: this.customer,
      Type: this.type.toObject(),
      ExpireDate: this.expireDate,
      FileName: this.fileName,
    };
    return result;
  }

  public constructor() {
    this.type = new CustomerContractTypeModel();
  }

  public customerContractId: number;
  public customer: number;
  public createUser: UserModel;
  public type: CustomerContractTypeModel;
  public createDate: Date;
  public expireDate: Date;
  public isActive: Boolean;
  public fileName: string;
}
